import { AxiosError } from 'axios'
import { useQuery, UseQueryResult } from 'react-query'
import * as Sentry from '@sentry/react'

import { getMyPackageList } from '../../api/package'
import { PackageInfo } from '../../types'
import { processAnExpiredSession } from '../../utils/errorHandling'

export const useGetMyPackage = ({
  userOid,
  sessionToken,
}: {
  userOid: string | undefined
  sessionToken: string | undefined
}): UseQueryResult<PackageInfo[], unknown> =>
  useQuery(
    ['get-my-package', userOid],
    () =>
      getMyPackageList({
        userOid,
        sessionToken,
      } as any),
    {
      enabled: userOid !== undefined && sessionToken !== undefined,
      onError: (e: AxiosError) => {
        console.dir(e)
        switch (e.response?.status) {
          case 403:
            processAnExpiredSession()
            break
          default:
            Sentry.captureException(
              new Error(
                `get my package useroid: ${userOid} message ::` + e.message,
              ),
            )
        }
      },
    },
  )
